import React, { useEffect, useState } from "react";
import classes from "./TypeDiagnosisTop.module.scss";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import { useNavigate } from "react-router-dom";
import headerImage from "../../static/images/typeDiagnosis/DiagnosisTopHeader.svg";
import topImage from "../../static/images/typeDiagnosis/DiagnosisTop.png";
import { fetchUser} from "../../api/UsersApi";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import charJumpImage from "../../static/images/prepare/char-jump.png";

function TypeDiagnosisTop() {
  const navigate = useNavigate();
  const userApi = fetchUser();

  useEffect(() => {
    userApi.fetch();
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.banner}>
        子育てと資産形成のスタイル・教育資金のシミュレーション
      </div>
      <img className={classes.header} src={headerImage} alt={headerImage} />
      <img className={classes.top} src={topImage} alt={topImage} />
      <div className={classes.buttonArea}>
        <img className={classes.buttonImage} src={charJumpImage} alt={charJumpImage} />
        <SimpleButton
          label="診断スタート"
          width="90%"
          color="orange"
          isRadius={true}
          onClick={() => navigate("/type9-diagnosis-contents")}
        />
      </div>
        <>
          {userApi?.state?.data?.[0].diagnosisType !== "no_diagnosis" && (
            <div
              className={classes.link}
              onClick={() => navigate("/type9-diagnosis-result")}
            >
              過去の診断はこちら
            </div>
          )}
          <div className={classes.link} onClick={() => navigate("/top")}>
            トップページ
          </div>
        </>
      <BreadCrumb
        data={[
          { displayName: "みらいいコンシェル", url: "/top" },
          { displayName: "子育てとおカネの9タイプ診断" },
        ]}
      />
    </div>
  );
}

export default TypeDiagnosisTop;
